import { Card } from '@mews-commander/ui';
import { Highlight, IconList, IconListItemProps, IconName, Link, Stack } from '@optimus-web/core';
import { lt } from '@mews/framework';
// TODO: https://mews.atlassian.net/browse/CON-6960
// import { useAdaChatBotContext } from '@mews/framework';

const getIconListItems = (/* handleClick: () => Promise<void> */): IconListItemProps[] => [
    {
        key: 'university',
        label: (
            <Link
                icon={IconName.ExternalLink}
                underline={false}
                variant="basic"
                href="https://university.mews.com"
                target="_blank"
                rel="noreferrer"
            >
                {lt('OnboardingAuditHelpAndSupportItemUniversityLabel')}
            </Link>
        ),
        description: lt('OnboardingAuditHelpAndSupportItemUniversityDescription'),
        icon: IconName.Education,
        variant: 'basic',
    },
    {
        key: 'help',
        label: (
            <Link
                icon={IconName.ExternalLink}
                underline={false}
                variant="basic"
                href="https://help.mews.com"
                target="_blank"
                rel="noreferrer"
            >
                {lt('OnboardingAuditHelpAndSupportItemHelpLabel')}
            </Link>
        ),
        description: lt('OnboardingAuditHelpAndSupportItemHelpDescription'),
        icon: IconName.Help,
        variant: 'basic',
    },
    {
        key: 'community',
        label: (
            <Link
                icon={IconName.ExternalLink}
                underline={false}
                variant="basic"
                href="https://community.mews.com"
                target="_blank"
                rel="noreferrer"
            >
                {lt('OnboardingAuditHelpAndSupportItemCommunityLabel')}
            </Link>
        ),
        description: lt('OnboardingAuditHelpAndSupportItemCommunityDescription'),
        icon: IconName.Countries,
        variant: 'basic',
    },
    // {
    //     key: 'ada',
    //     label: (
    //         <Link onClick={async () => handleClick()} icon={IconName.ExternalLink} underline={false} variant="basic">
    //             {lt('OnboardingAuditHelpAndSupportItemAdaLabel')}
    //         </Link>
    //     ),
    //     description: lt('OnboardingAuditHelpAndSupportItemAdaDescription'),
    //     icon: IconName.CustomerSuccess,
    //     variant: 'basic',
    // },
];

export const HelpSupport = () => {
    // TODO: https://mews.atlassian.net/browse/CON-6960
    // const { start, isStarted, isChatButtonHidden, showChatButton } = useAdaChatBotContext();
    //
    // const handleClick = async () => {
    //     if (!isStarted) {
    //         await start();
    //     } else if (isChatButtonHidden) {
    //         showChatButton();
    //     }
    // };

    return (
        <Card padding="300">
            <Stack spacing="250" vertical>
                <Highlight size="small">{lt('OnboardingAuditHelpAndSupportSectionTitle')}</Highlight>
                <IconList small items={getIconListItems(/* handleClick */)} />
            </Stack>
        </Card>
    );
};
